import { useEffect, useState } from "react";
import { HoldCleaningWorkflowModal, WorkflowField, workflowInputClass } from "./HoldCleaningWorkflowModal";

export const HoldCleaningNoteModal = ({
  open,
  onClose,
  onSave,
}: {
  open: boolean;
  onClose: () => void;
  onSave: (text: string) => Promise<void>;
}) => {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    if (open) { setText(""); setError(null); }
  }, [open]);
  const submit = async () => {
    if (!text.trim()) { setError("Enter a note before saving."); return; }
    setBusy(true);
    setError(null);
    try { await onSave(text.trim()); onClose(); } catch (requestError) {
      setError(requestError instanceof Error ? requestError.message : "The note could not be saved.");
    } finally { setBusy(false); }
  };
  return (
    <HoldCleaningWorkflowModal open={open} title="Add note" description="Notes are timestamped, attributed and append-only." busy={busy} error={error} submitLabel="Add note" onClose={onClose} onSubmit={submit}>
      <WorkflowField label="Note">
        <textarea value={text} onChange={(event) => setText(event.target.value)} maxLength={5000} rows={7} className={workflowInputClass} />
      </WorkflowField>
    </HoldCleaningWorkflowModal>
  );
};
